import { render } from "./TodoList.vue?vue&type=template&id=db539ccc&scoped=true"
import script from "./TodoList.vue?vue&type=script&lang=js"
export * from "./TodoList.vue?vue&type=script&lang=js"

import "./TodoList.vue?vue&type=style&index=0&id=db539ccc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-db539ccc"

export default script